<template>
    <div class="program-card">
        <router-link class="card" :to="{ name: 'program', params: { id: program.id } }">
            <div class="left" :style="program.images[0] | bgstyle"></div>
            <div class="right">
                <div class="top">
                    <span v-if="program.date">{{program.date}}</span>
                    <span v-else>EVERYDAY</span>
                    <span class="top__type">{{program.type | programType}}</span>
                </div>
                <h1 class="name">{{program.name}}</h1>
                <div class="down">
                    <p class="oneliner">{{program.oneliner}}</p>
                    <p class="info">
                        <img class="info__icon" src="~@/assets/card-icon-time.png">
                        <span v-if="program.timeStart">{{program.timeStart}} ({{program.timeTaking}})</span>
                        <span v-else>{{program.timeTaking}}</span>
                        <img class="info__icon" src="~@/assets/card-icon-people.png">
                        <span>{{program.cap}}</span>
                        <img class="info__icon" src="~@/assets/card-icon-money.png">
                        <span>{{program.fee}}</span></p>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
import { programType } from '@/core/type'

export default {
    name: 'ProgramCard',
    filters: {
        programType
    },
    props: {
        program: null
    },
    data() {
        return {
            spot: null
        }
    },
    async mounted() {
        this.spot = (await this.program.linkWith.get()).data()
    }
}
</script>

<style scoped lang="scss">
@import '~@/styles/_parts';

.program-card {
    height: em(145);
}
.card {
    height: 100%;
    background: #fff;
    border: 1px solid #342264;
    box-shadow: 2px 2px 4px 0 rgba(20, 4, 59, 0.5);
    color: #342264;
    display: flex;
    position: relative;
}

.left {
    width: em(122);
    height: 100%;
    background: center no-repeat;
    background-size: cover;
    flex-shrink: 0;
}
.right {
    flex-grow: 1;
    margin-left: em(12);
    padding: em(8) em(12) em(8) 0;
    position: relative;
}

.top {
    color: #200e62;
    display: flex;
    justify-content: space-between;
    font-family: 'Fugaz One', sans-serif;
    font-size: em(11);
}
.top__type {
    text-transform: uppercase;
}

.name {
    font-size: 1.05em;
    font-weight: 700;
    line-height: 1.35em;
    margin-top: 3px;
}

.down {
    font-size: em(10);
    position: absolute;
    right: 8px;
    bottom: 10px;
    left: 0;
}
.oneliner {
    font-size: 1.05em;
    line-height: 1.45;
}
.info {
    display: flex;
    justify-content: flex-end;
    line-height: 1.7;
    margin-top: 5px;
    margin-left: -4px;
}
.info__icon {
    height: 1.4em;
    margin-right: .25ch;
    margin-left: .6em;
}
.info__cap {
    margin-right: 1em;
}
</style>